<template>
  <div class="vld-parent" ref="startup_calls">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-4">
              Aqui você confere todas as chamadas para startups Stars que estão
              com inscrições abertas. Se atente ao prazos e, em caso de dúvidas,
              contate o suporte.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <startup-call-list v-if="!empty" :data="calls" />
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Não existem chamadas para startups em aberto no momento.
              </badge>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-5 mb-1" />
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            @click="$router.push('/startup/chamadas/inscricoes')"
            >Minhas inscrições</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="showModal"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">Prezado(a),</h4>
        <p class="my-4">
          Não existem
          <span class="text-warning font-weight-400"
            >chamadas para startups STARS</span
          >
          com inscrições em aberto no momento. Em caso de dúvidas, sinta-se
          livre para
          <base-button
            type="danger"
            class="ml-auto"
            size="sm"
            @click="$router.push('/startup/suporte')"
            >Contatar o suporte
          </base-button>
        </p>
        <p class="text-right mt-4">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
      <template slot="footer">
        <base-button type="white" @click="$router.push('/')">
          Voltar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import StartupCallList from "@/components/StartupCallList";

export default {
  name: "chamadas",
  components: {
    StartupCallList,
  },
  data() {
    return {
      calls: [],
      empty: false,
      showModal: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.startup_calls,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data: openCalls } = await api.get(
        "/startup-calls?only_open=true"
      );
      const { data: subscriptions } = await api.get(
        "/startup-call-subscriptions"
      );
      subscriptions.forEach((subscription) => {
        const index = openCalls.findIndex(
          (call) => call.id === subscription.startup_call_id
        );
        if (index >= 0) openCalls[index].subscription_id = subscription.id;
      });
      if (openCalls.length) this.calls = openCalls;
      else this.empty = this.showModal = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
};
</script>
